module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appList"
  }, [_c('nav', {
    staticClass: "navbar navbar-inverse cipSelection"
  }, [_c('div', {
    staticClass: "container-fluid cipInfos"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cipID),
      expression: "cipID"
    }],
    staticClass: "cipDropdown",
    attrs: {
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cipID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeRoute]
    }
  }, [_c('option', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "value": "0",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("\n          ---- Please Choose ----\n        ")]), _vm._v(" "), _vm._l((_vm.filteredCipList), function(cip) {
    return _c('option', {
      key: cip.cipID,
      domProps: {
        "value": cip.cipID
      }
    }, [_vm._v("\n          " + _vm._s(cip.cipID) + " - " + _vm._s(cip.cipName) + "\n        ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "btn-group cipSearch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search Project by name"
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "exportProject"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Export Image Assets codebook"
    },
    on: {
      "click": _vm.ExportProjectInfo
    }
  }, [_vm._v("\n          Export Implicit Projects\n        ")])])])]), _vm._v(" "), _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cipID),
      expression: "cipID"
    }],
    staticClass: "navbar navbar-default cipFunction"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-left navbar-form"
  }, [_c('router-link', {
    attrs: {
      "activeClass": "active",
      "tag": "a",
      "to": {
        name: 'pgnatConfig',
        query: {
          projectID: 0,
          cipID: _vm.cipID,
        },
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "create PGNAT project",
      "disabled": _vm.cipID === '0'
    }
  }, [_vm._v("\n            Add PGNAT\n          ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "activeClass": "active",
      "tag": "a",
      "to": {
        name: 'gnatConfig',
        query: {
          projectID: 0,
          cipID: _vm.cipID,
        },
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "create GNAT project",
      "disabled": _vm.cipID === '0'
    }
  }, [_vm._v("\n            Add GNAT\n          ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "activeClass": "active",
      "tag": "a",
      "to": {
        name: 'aptConfig',
        query: {
          projectID: 0,
          cipID: _vm.cipID,
        },
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "create APT project",
      "disabled": _vm.cipID === '0'
    }
  }, [_vm._v("\n            Add APT\n          ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-right dataExport"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "assets/zoneInformation.docx",
      "target": "_blank",
      "title": "Download original zone definition"
    }
  }, [_vm._v("Zone Library")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Export Image Assets codebook",
      "disabled": _vm.cipID === '0'
    },
    on: {
      "click": _vm.exportRNMapping
    }
  }, [_vm._v("\n          Asset Mapping Export\n        ")])])])]), _vm._v(" "), _c('appProjectList', {
    attrs: {
      "cipID": _vm.cipID
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce590cd8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectHome.vue
// module id = 49
// module chunks = 0